module.exports = __webpack_public_path__ + "img/shopping.fee3df90.svg";